import { render, staticRenderFns } from "./HelloDecorator.vue?vue&type=template&id=1daead39&"
import script from "./HelloDecorator.vue?vue&type=script&lang=ts&"
export * from "./HelloDecorator.vue?vue&type=script&lang=ts&"
import style0 from "./HelloDecorator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cv/cv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1daead39')) {
      api.createRecord('1daead39', component.options)
    } else {
      api.reload('1daead39', component.options)
    }
    module.hot.accept("./HelloDecorator.vue?vue&type=template&id=1daead39&", function () {
      api.rerender('1daead39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HelloDecorator.vue"
export default component.exports